var _a;
import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
import { reduxModuleLoaded } from './actions';
var reducers = handleActions((_a = {},
    _a[reduxModuleLoaded.toString()] = function (state, action) { return (__assign(__assign({}, state), { reduxReady: true })); },
    _a), {
    reduxReady: false,
});
export default reducers;
//# sourceMappingURL=reducer.js.map